import React, { useState, useEffect } from "react";
import TypewriterText from "../components/TypeWriterText";
import { Link } from "react-router-dom";

const pages = [
  { title: " Curators Foreword", path: "/foreword-economics" },

  {
    title: "Day 26: Choices, Scarcity, and Purpose",
    path: "/economics-26",
  },
  {
    title: "Day 27: The Broken Window Fallacy",
    path: "/economics-27",
  },
  {
    title: "Day 28: Value: A Subjective Perspective",
    path: "/economics-28",
  },
  {
    title: "Day 29: Marginalism: The Core of Economic Decision-Making",
    path: "/economics-29",
  },
  {
    title: "Day 30: How Taxes Undermine Economic Progress",
    path: "/economics-30",
  },
  {
    title: "Day 31: The Illusion of Credit-Driven Productivity",
    path: "/economics-31",
  },
  {
    title:
      "Day 32: Machines and Labor: A History of Cooperation, Not Conflict ",
    path: "/economics-32",
  },
  {
    title: "Day 33: Misconception of Forced Labor Division",
    path: "/economics-33",
  },
  {
    title: "Day 34: Parity Pricing: A Zero-Sum Policy",
    path: "/economics-34",
  },
  {
    title: "Day 35: Why Inefficient Industries Should Be Allowed to Die",
    path: "/economics-35",
  },
  {
    title: "Day 36: How the Price System Guides Economic Efficiency",
    path: "/economics-36",
  },
  {
    title: "Day 37: The Economic Rationale of Ownership and Property Rights",
    path: "/economics-37",
  },
  {
    title: "Day 38: The Case Against Rent Control",
    path: "/economics-38",
  },
  {
    title: "Day 39: Unpacking Minimum Wage Laws",
    path: "/economics-39",
  },
  {
    title: "Day 40: The Destruction Caused by Inflation",
    path: "/economics-40",
  },
  {
    title: "Day 41: The Case for Capital Accumulation",
    path: "/economics-41",
  },
  {
    title: "Day 42: The Concept of Time Preference",
    path: "/economics-42",
  },
  {
    title: "Day 43: What makes Money, Money",
    path: "/economics-43",
  },
  {
    title: "Day 44: Banking, Credit, and the Question of Interest",
    path: "/economics-44",
  },
   {
    title: "Day 45: Case Study - Hyperinflation in Weimar Germany",
    path: "/economics-44",
  },
];

const IndexEconomics = () => {
  const [visibleItems, setVisibleItems] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null); // New state for hover tracking
  const titleText = "Principles of Austrian Economics";
  useEffect(() => {
    pages.forEach((_, index) => {
      const delay = 50 * index;
      const timeoutId = setTimeout(() => {
        setVisibleItems((prevItems) => [...prevItems, index]);
      }, delay);
      return () => clearTimeout(timeoutId);
    });
  }, []);

  // Define the base style object for all links
  const baseLinkStyle = {
    fontSize: "18px",
    width: "100%", // Take full width for consistent border/hover area
    padding: "15px 20px", // Increased padding for better visual spacing
    margin: "0", // Remove vertical margin from Link component
    textDecoration: "none", // Remove default underline
    borderBottom: "1px solid #eee", // Light separator line
    color: "black",
    cursor: "pointer",
    textAlign: "left", // Align text to the left for better readability

    // Combined transitions for smooth effects
    transition:
      "color 0.3s ease, background-color 0.3s ease, transform 0.3s ease, opacity 0.5s ease, border-color 0.3s ease",
  };

  // Define the hover style
  const hoverStyle = {
    backgroundColor: "#f9f9f9", // Very light grey background on hover
    color: "#034d28", // Dark Green text on hover (your primary color)
    transform: "translateX(5px)", // Subtle slide-right effect
    borderBottomColor: "#034d28", // Dark Green border on hover
  };

  return (
    <div
      style={{
          width: "95%",

        margin: "40px auto",
        padding: "0", // Remove padding to allow links to touch edges
        backgroundColor: "white",
        border: "2px solid #ccc",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch", //
        fontFamily: "Georgia, sans-serif",
        lineHeight: "1.6",
        letterSpacing: "0.3px",
      }}
    >
      <h1
        style={{
          fontSize: "30px",
          fontWeight: "bold",
          textAlign: "center",
          marginBottom: "20px",
          marginTop: "20px",
          color: "black",
          padding: "0 20px", // Add padding back to the title
        }}
      >
        <b>Table of Contents</b>
        <br />
        <TypewriterText
          text={titleText}
          delay={80} // Typing speed for the title
        />
      </h1>
      {pages.map((page, index) => {
        const isVisible = visibleItems.includes(index);
        const isHovered = hoveredIndex === index;

        return (
          <Link
            key={index}
            to={page.path}
            // Merge base style, animation style, and hover style
            style={{
              ...baseLinkStyle,
              ...(isVisible
                ? {}
                : { opacity: 0, transform: "translateY(20px)" }), // Animation style
              ...(isHovered ? hoverStyle : {}), // Hover style
            }}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            {page.title}
          </Link>
        );
      })}
    </div>
  );
};

export default IndexEconomics;
